module.exports = __webpack_public_path__ + "img/LOVE.2391ab5a.png";